import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../../i18n/LanguageContext';
import './Footer.css';

const SOCIALS = [
  { href: 'https://open.spotify.com/artist/1QhaqxeqF9sipS2gwbEKpu', label: 'Spotify',     icon: 'fa-brands fa-spotify' },
  { href: 'https://www.youtube.com/channel/UCkD89TEFWsTZluY6tk84yqg', label: 'YouTube',   icon: 'fa-brands fa-youtube' },
  { href: 'https://music.apple.com/us/artist/c-kan/395579929',       label: 'Apple Music', icon: 'fa-brands fa-apple' },
  { href: 'https://www.instagram.com/ckan98',                        label: 'Instagram',  icon: 'fa-brands fa-instagram' },
  { href: 'https://www.facebook.com/CKanMEX',                        label: 'Facebook',   icon: 'fa-brands fa-facebook-f' },
  { href: 'https://x.com/ckan98',                                    label: 'X / Twitter', icon: 'fa-brands fa-x-twitter' },
];

export default function Footer() {
  const { t } = useT();
  const year = new Date().getFullYear();

  const NAV = [
    { label: t('nav.home'), to: '/',        type: 'router' },
    { label: t('nav.tour'), to: '/eventos', type: 'router' },
    { label: t('nav.music'), to: '/videos', type: 'router' },
    { label: t('nav.bio'),  to: '/aboutme', type: 'router' },
    { label: t('nav.shop'), to: 'https://masteredtrax.shop', type: 'external' },
  ];

  return (
    <footer className="ft">
      {/* Top CTA strip */}
      <div className="ft__cta">
        <div className="ft__cta-inner">
          <div>
            <span className="ck-eyebrow">{t('footer.ctaEyebrow')}</span>
            <h3 className="ft__cta-title">{t('footer.ctaTitle')}</h3>
          </div>
          <a href="mailto:booking@masteredtrax.com" className="ck-btn">
            {t('footer.ctaButton')}
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M13 6l6 6-6 6" />
            </svg>
          </a>
        </div>
      </div>

      {/* Main footer */}
      <div className="ft__main">
        <div className="ft__grid">
          {/* Brand column */}
          <div className="ft__brand">
            <Link to="/" className="ft__logo" aria-label="C-Kan">
              <img src={process.env.PUBLIC_URL + '/assets/nav-logo.png'} alt="C-Kan" />
            </Link>
            <p className="ft__tag">{t('footer.brandTag')}</p>

            <div className="ft__socials">
              {SOCIALS.map(s => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="ft__social"
                >
                  <i className={s.icon} />
                </a>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div className="ft__col">
            <h4 className="ft__h">{t('footer.explore')}</h4>
            <ul>
              {NAV.map(n => (
                <li key={n.label}>
                  {n.type === 'external' ? (
                    <a href={n.to} target="_blank" rel="noopener noreferrer">{n.label}</a>
                  ) : (
                    <Link to={n.to}>{n.label}</Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Booking */}
          <div className="ft__col">
            <h4 className="ft__h">{t('footer.booking')}</h4>
            <ul className="ft__contact">
              <li>
                <span>USA</span>
                <a href="https://wa.me/14084997909" target="_blank" rel="noopener noreferrer">+1 (408) 499 7909</a>
              </li>
              <li>
                <span>MX</span>
                <a href="https://wa.me/523324328573" target="_blank" rel="noopener noreferrer">+52 332 432 8573</a>
              </li>
              <li>
                <span>MX</span>
                <a href="tel:+523311960087">+52 331 196 0087</a>
              </li>
              <li>
                <span>Email</span>
                <a href="mailto:booking@masteredtrax.com">booking@masteredtrax.com</a>
              </li>
            </ul>
          </div>

          {/* Management */}
          <div className="ft__col">
            <h4 className="ft__h">{t('footer.management')}</h4>
            <ul className="ft__contact">
              <li>
                <span>Joe</span>
                <a href="mailto:joe@masteredtrax.com">joe@masteredtrax.com</a>
              </li>
              <li>
                <span>Label</span>
                <a href="https://masteredtrax.shop" target="_blank" rel="noopener noreferrer">masteredtrax.com</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Big wordmark */}
        <div className="ft__wordmark" aria-hidden="true">C-KAN</div>

        {/* Bottom bar */}
        <div className="ft__bottom">
          <p>&copy; {year} C-Kan · {t('footer.copyright')}</p>
          <p className="ft__legal">{t('footer.legal')}</p>
          <Link to="/admin" className="ft__admin-dot" aria-label="Admin" tabIndex={-1}>
            <span />
          </Link>
        </div>
      </div>
    </footer>
  );
}
